const METRIKA_ID = 110028033;

declare global {
  interface Window {
    ym?: (id: number, method: string, ...args: unknown[]) => void;
  }
}

export function trackMetrikaHit(path: string): void {
  const url = path.startsWith('http') ? path : location.origin + path;
  window.ym?.(METRIKA_ID, 'hit', url, { title: document.title });
}
